import React, { useEffect } from 'react';
import { textCss } from '../common/Css';
import { useDispatch } from 'react-redux';
import { RaisePOForm } from '../components/RaisePO/RaisePoForm';
import IconToolTip from '../common/IconToolTip';
import { closeFullScreenModalAction } from '../actions/modal';
import { useNavigate } from 'react-router-dom';

export default function RaisePo({ ticketId, heading = 'Raise PO' }) {
    const dispatch = useDispatch();
    const closeModal = () => dispatch(closeFullScreenModalAction());
    const navigate = useNavigate();

    useEffect(() => {
        document.title = "RaisePo";
    }, []);


    return (
        <div className='subContainer title-4 px-5 pt-5'>
            <div className={`titleContainer sticky  w-full z-20`}>
                <div className='md:flex max-w-full justify-between'>
                    <div className='flex items-center gap-2'>
                        <div
                            onClick={() => navigate(-1)}
                            className='hover:text-scogoorange hover:bg-white pr-2 py-1 hover:shadow-md text-scogoprimary cursor-pointer flex items-center text-font20  rounded-md'
                        >
                            <span className='material-icons  m-0 font-bold '>chevron_left</span>
                            <span className='m-0'>BACK</span>
                        </div>
                        <h1 className={textCss?.moduleTitle}>{heading}</h1>
                    </div>
                    <div className='ml-auto cursor-pointer' onClick={() => navigate(-1)}>
                        <IconToolTip title='Close'>
                            <span className='material-icons text-scogoprimary font-medium align-middle text-4xl hover:text-scogoorange'>highlight_off</span>
                        </IconToolTip>
                    </div>
                </div>
            </div>
            <RaisePOForm closeModal={closeModal} ticketId={ticketId} />
        </div>
    );
}
